import { render, staticRenderFns } from "./BaseProgressBar.vue?vue&type=template&id=389b57ed&scoped=true&"
import script from "./BaseProgressBar.vue?vue&type=script&lang=js&"
export * from "./BaseProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseProgressBar.vue?vue&type=style&index=0&id=389b57ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b57ed",
  null
  
)

export default component.exports